import { useEffect, useState, useCallback } from 'react';
import { apiFetch } from '@/lib/auth';

export interface RingingCall {
  callId: string;
  groupId: string;
  groupName: string;
  steleName: string;
  startedAt: string;
  pickupEnabled: boolean;
}

/**
 * Welle 9: Aktuell klingelnde Calls des Mandanten.
 * Initial per REST geladen, danach live über Socket-Events gepflegt
 * (bamoa:call-ringing fügt hinzu, bamoa:call-cleared entfernt).
 * Das Filtern auf eigene Gruppen übernimmt die Ansicht.
 */
export function useRingingCalls() {
  const [calls, setCalls] = useState<RingingCall[]>([]);

  const load = useCallback(async () => {
    try {
      const r = await apiFetch('/api/calls/ringing');
      if (!r.ok) return;
      const data = await r.json();
      if (Array.isArray(data)) setCalls(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    void load();

    function onRinging(e: any) {
      const c = e.detail as RingingCall;
      if (!c?.callId) return;
      setCalls((prev) => (prev.some((x) => x.callId === c.callId) ? prev : [...prev, c]));
    }
    function onCleared(e: any) {
      const id = e.detail?.callId;
      if (!id) return;
      setCalls((prev) => prev.filter((x) => x.callId !== id));
    }
    function onLogin() { void load(); }
    window.addEventListener('bamoa:call-ringing', onRinging);
    window.addEventListener('bamoa:call-cleared', onCleared);
    window.addEventListener('bamoa:logged-in', onLogin);
    return () => {
      window.removeEventListener('bamoa:call-ringing', onRinging);
      window.removeEventListener('bamoa:call-cleared', onCleared);
      window.removeEventListener('bamoa:logged-in', onLogin);
    };
  }, [load]);

  return { calls };
}
